import { render, staticRenderFns } from "./config-notifications.vue?vue&type=template&id=301d9c70&"
import script from "./config-notifications.vue?vue&type=script&lang=js&"
export * from "./config-notifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports